<div class="ui vertical basic segment wrap" appPadding="0">
  <div
    class="ui vertical basic segment empty-data-view"
    appPadding="0"
    [ngClass]="{ loading: pending }"
  >
    <div class="content" fxLayout="column" fxLayoutAlign="center center">
      <img src="assets/images/empty-data.svg" alt="" />
      <div class="text">
        <h3 class="heading">
          Your Conversation Screen is empty.
          <br />
          Start chatting to see conversation screen
        </h3>
      </div>
    </div>
  </div>
</div>
